export default "__VITE_ASSET__CkAcZhZF__"